import { render, staticRenderFns } from "./CompanyLogo.vue?vue&type=template&id=35be6c04&scoped=true&"
import script from "./CompanyLogo.vue?vue&type=script&lang=js&"
export * from "./CompanyLogo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyLogo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CompanyLogo.vue?vue&type=style&index=1&id=35be6c04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35be6c04",
  null
  
)

export default component.exports